import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface WarningCircleFillIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const WarningCircleFillIcon = ({ className, ...props }: WarningCircleFillIconProps) => (
  <svg
    className={cn("text-[#D93025]", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12.5117 16.4414C12.2038 16.1643 11.7292 16.1892 11.4521 16.4971L11.4424 16.5078C11.1653 16.8156 11.1903 17.2903 11.498 17.5674C11.8059 17.8445 12.2805 17.8196 12.5576 17.5117L12.5674 17.501C12.8445 17.1931 12.8196 16.7185 12.5117 16.4414ZM12 6.25C11.5858 6.25 11.25 6.58579 11.25 7V13C11.25 13.4142 11.5858 13.75 12 13.75C12.4142 13.75 12.75 13.4142 12.75 13V7C12.75 6.58579 12.4142 6.25 12 6.25Z"
      fill="currentColor"
    />
  </svg>
);

export default WarningCircleFillIcon;
